import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { http } from "@/lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }

    (async () => {
      try {
        const r = await http.post("/auth/session", { session_id: sessionId });
        window.history.replaceState({}, document.title, "/admin");
        navigate("/admin", { replace: true, state: { user: r.data } });
      } catch (e) {
        navigate("/admin", { replace: true });
      }
    })();
  }, [location.hash, navigate]);

  return (
    <div className="min-h-screen bg-[#FAFAFA] grid place-items-center" data-testid="auth-callback">
      <div className="tick-label">Signing in…</div>
    </div>
  );
}
